import { nameCase } from '@foundernest/namecase';
import pluralize from 'pluralize';
import slugify from 'slugify';
import english from './data/english';

export const text = {
	pluralize,
	slugify: (text: string) => slugify(text, { lower: true, strict: true }),
	firstLetterUppercase: (str: string) => str.charAt(0).toUpperCase() + str.slice(1),
	slug: (str: string) => slugify(str, { lower: true }),
	name: (str: string) => {
		return nameCase(str.trim());
	},
	removeAccents: (str: unknown) => {
		return str
			? str
					.toString()
					.normalize('NFD')
					.replace(/[\u0300-\u036f]/g, '')
			: '';
	},
	english(text: string): string {
		if (typeof text !== 'string') return text;
		const string = this.removeAccents(text);
		const t = english.find((s) => string.toLowerCase().includes(s.word.toLowerCase()));
		if (!t) {
			return string;
		}
		const from = t.word;
		const re = new RegExp(from, 'gi');
		const result = string.replace(re, t.trans);
		if (result) return result;
		return string;
	},
	parse(text: string): string {
		if (typeof text !== 'string') return text;
		const string = this.removeAccents(text);
		const result = string
			.replace(/[^a-zA-Z0-9, ]/g, ' ')
			.replace(/\s+/g, ' ')
			.trim();
		if (result) return result;
		return string;
	},
	/**
	 * Parses a phone number value.
	 *
	 * @param {unknown} val - The value to parse.
	 * @returns {string|undefined|null} The parsed phone number, or `undefined` if the value is `undefined`, or `null` if the value is `null`.
	 */
	parsePhone: (val: unknown): string | undefined => {
		if (val == null) return undefined; // Check for both null and undefined
		return String(val).trim().replace(/\s/g, '');
	},
	duration(seconds: number) {
		const minutes = Math.floor(seconds / 60);
		const hours = Math.floor(minutes / 60);
		const min = minutes % 60;

		let duration = hours > 0 ? `${hours} ${pluralize('hour', hours)}` : '';
		duration += min > 0 ? ` ${min} ${pluralize('minute', min)}` : '';
		return duration.trim();
	}
};
